import $ from "jquery";

(function($) {
    let cboxOptions = {
        width: '95%',
        height: '95%',
        maxWidth: '960px',
        maxHeight: '700px',
        top: '15%',
        iframe: true,
    }

    function productVideo() {
       let $iframe = $('a.product-video').colorbox(cboxOptions);

       return $iframe;
    }

    function resizeColorbox($iframe) {
       $iframe.colorbox.resize({
            width: window.innerWidth > parseInt(cboxOptions.maxWidth) ? cboxOptions.maxWidth : cboxOptions.width,
            height: window.innerHeight > parseInt(cboxOptions.maxHeight) ? cboxOptions.maxHeight : cboxOptions.height
        });
    }

    $(window).on('load', function() {
        productVideo();
    });

    $(window).on('resize', function() {
        resizeColorbox(productVideo());
    });

})(jQuery);